const createLoginRu = {
  'createLogin': {
    'loginLabel': 'Логин',
    'requirementsTitle': 'Логин должен содержать:',
    'requirements': {
      'symbolsCount': 'от {{minLength}} до {{maxLength}} символов',
      'letters': 'латинские буквы и/или цифры',
    },
  },
};

export default createLoginRu;
